import React from 'react';

const Hero = ({ content }) => {
    return (
           <div>
             <div className="hero-overlay absolute inset-0 bg-black opacity-60"></div>
            <div className="container mx-auto text-center relative z-10 px-4">
                <h1 className="text-4xl md:text-6xl font-bold mb-4" style={{ color: content?.titleColor || '#111827' }}>{content?.title || 'LOS SANTOS'}</h1>
                <h2 className="text-7xl md:text-7xl mb-4" style={{ color: content?.subtitleColor || '#e53e3e', fontFamily: "Roboto, sans-serif",fontWeight: 800, textShadow: '-2px 0px 0px white, 2px 0px 0px white, 0px -2px 0px white, 0px 2px 0px white, -2px -2px 0px white, 2px -2px 0px white, -2px 2px 0px white, 2px 2px 0px white'}}>{content?.subtitle || 'FIRE DEPARTMENT'}</h2>
                <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto" style={{ color: content?.descriptionColor || '#111827' }}>
                    {content?.description || '"We are here to protect lives and property. With courage and determination, we serve the community of Los Santos."'}
                </p>
 <a href={content?.discordUrl && !content?.discordUrl.startsWith('http') ? `https://${content.discordUrl}` : content?.discordUrl} target="_blank" rel="noopener noreferrer">
 <button className="btn-primary bg-red-600 text-white py-3 px-6 rounded-lg hover:bg-red-700 transition duration-300" style={{ color: content?.discordButtonTextColor || '#111827' }}>
                    {content?.discordButtonText || 'Discord'}
 </button>
 </a>
            </div>   
            </div>
    );
};
export default Hero;